import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {PaginatedResponseModel} from '../../models/paginated.response.model';
import {HttpClient} from '@angular/common/http';
import {PreorderStatus} from './preorderStatus.enum';
import {PreorderListModel} from './preorderList.model';
import {PreorderModel} from './preorder.model';

@Injectable({
  providedIn: 'root'
})
export class PreorderService {
  constructor(private http: HttpClient) {
  }

  getPaginated(page: number, size: number, reference: string, status: PreorderStatus): Observable<PaginatedResponseModel<PreorderListModel>>
  {
    const params: {
      page: string,
      size: string,
      reference?: string,
      status?: PreorderStatus
    } = {
      page: page.toString(),
      size: size.toString(),
    };
    if (reference) { params.reference = reference; }
    if (status) { params.status = status; }

    return this.http.get<PaginatedResponseModel<PreorderListModel>>(`/v2/admin/preorder`, { params });
  }

  getDetailsById(reference: string): Observable<PreorderModel> {
    return this.http.get<PreorderModel>(`/v2/admin/preorder/${reference}`);
  }
}
